const multiBoxCarousel = ($carousel) => {
    // Jeśli mobile — Przywracam układ mobile
    if (rwd.ScreenSize.is(rwd.ScreenSize.SIZES.SMALL) || rwd.ScreenSize.is(rwd.ScreenSize.SIZES.XSMALL) ) {
        $carousel.removeClass('carouselDotsMultiBox');

        // Pobieramy wszystkie divy z wrapperów w li (czyli zawartość karuzeli)
        const $items = $carousel.find('.content_carousel__wrapperContent');

        // Czyścimy karuzelę
        $carousel.empty();

        // Dodajemy każdy element z powrotem w osobnym li
        $items.each((_, div) => {
            const $li = $('<li>').append(div);
            $carousel.append($li);
        });
        $carousel.attr('tabindex', '-1');
        return;
    } else {
        // Tutaj po powrocie z czyszczenia karuzeli muszę zadbać o dopięcie klas
        const $lis = $carousel.find('li');
        if ($lis.length === 3 && !$lis.first().hasClass('content_carousel__item')) {
            $lis.addClass('content_carousel__item');
        }
    }

    // Jeśli już itnieje albo ma mniej niż 3 elementy — nie odpalamy karuzeli
    if ($carousel.hasClass('carouselDotsMultiBox') || $carousel.find('li').length <= 3) return;

    $carousel.addClass('carouselDotsMultiBox');

    const $items = $carousel.find('li > .content_carousel__wrapperContent');
    $carousel.empty();

    // Dziele na pakiety po 3 i wrapuje w nowe <li>
    for (let i = 0; i < $items.length; i += 3) {
        const $li = $('<li>').addClass('list-item');
        const group = $items.slice(i, i + 3);
        group.each((_, div) => {
            $li.append(div);
        });
        $carousel.append($li);
    }

    $carousel.attr('tabindex', '-1');

};

const AccessibleCarouselDots = ($carousel, isMultiBoxCarousel = false) => {
    $carousel.addClass('carouselDots');
    const carouselElement = $carousel[0];

    let itemWidth;
    let visibleCount;
    let currentPage = 0;
    let dotsNav;

    const hasOverflowX = () =>
        window.getComputedStyle(carouselElement).overflowX === 'auto';

    const updateItemsAccessibility = (items) => {
        items.forEach((item, index) => {
            const start = currentPage * visibleCount;
            const end = start + visibleCount;
            const isVisible = index >= start && index < end;
            item.setAttribute('aria-hidden', !isVisible);
            const link = item.querySelector('a');
            link?.setAttribute('tabindex', isVisible ? '0' : '-1');
        });
    };

    const updateVisibility = (items) => {
        const scrollTo = currentPage * itemWidth * visibleCount;
        carouselElement.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
        });
    };

    const updateDots = () => {
        if (!dotsNav) return;
        const buttons = dotsNav.querySelectorAll('button');
        buttons.forEach((btn, index) => {
            const isActive = index === currentPage;
            btn.classList.toggle('is-active', isActive);
            isActive
                ? btn.setAttribute('aria-current', 'true')
                : btn.removeAttribute('aria-current');
        });
    };

    const renderDots = (totalPages, itemElementList) => {
        if ($carousel.next(".carouselDots__dots").length > 0) return;

        dotsNav = document.createElement('ul');
        dotsNav.className = 'carouselDots__dots';
        dotsNav.setAttribute('role', 'list');

        for (let i = 0; i < totalPages; i++) {
            const li = document.createElement('li');
            const btn = document.createElement('button');
            btn.type = 'button';

            // Pobranie tytułu slajdu z nagłówka kafla
            let slideTitle = '';
            if (itemElementList[i]) {
                const headerEl = itemElementList[i].querySelector('.carousel__headerLabel');
                if (headerEl) {
                    slideTitle = headerEl.textContent.trim();
                }
            }

            const baseLabel = `Slajd ${i + 1} z ${totalPages}`;
            const ariaLabel = slideTitle
                ? `${baseLabel}, ${slideTitle}`
                : baseLabel;

            btn.setAttribute('aria-label', ariaLabel);

            if (i === currentPage) {
                btn.setAttribute('aria-current', 'true');
                btn.classList.add('is-active');
            }

            btn.addEventListener('click', () => {
                currentPage = i;
                updateVisibility(itemElementList);
                updateDots();
            });

            li.appendChild(btn);
            dotsNav.appendChild(li);
        }

        $carousel.after(dotsNav);
    };

    const handleScroll = () => {
        const items = Array.from(carouselElement.children);
        if (!itemWidth || !visibleCount) return;
        const scrollPosition = carouselElement.scrollLeft;
        currentPage = Math.round(scrollPosition / (itemWidth * visibleCount));

        updateItemsAccessibility(items);
        updateDots();
    };

    const initializeCarousel = () => {
        if (!carouselElement) return;
        const items = Array.from(carouselElement.children);

        if (!hasOverflowX()) {
            const existingDots = $carousel.next(".carouselDots__dots");
            if (existingDots.length > 0) {
                existingDots.remove();
            }
            carouselElement.removeEventListener('scroll', handleScroll);
            return;
        }

        if (items.length < 2) return;

        itemWidth = items[0].offsetWidth;
        visibleCount = Math.floor(carouselElement.offsetWidth / itemWidth);
        const totalPages = Math.ceil(items.length / visibleCount);

        if (totalPages <= 1) return;

        updateVisibility(items);
        renderDots(totalPages, items);
        carouselElement.removeEventListener('scroll', handleScroll);
        carouselElement.addEventListener('scroll', handleScroll);
    };

    const handleResize = () => {
        if (isMultiBoxCarousel) {
            multiBoxCarousel($carousel);
        }
        initializeCarousel();
    };

    if (isMultiBoxCarousel) {
        multiBoxCarousel($carousel);
    }

    initializeCarousel();

    $(document).onPage(rwd.ScreenSize.RESIZE_EVENT_NAME, handleResize);
};
